import { actions } from '../../actions/authentication/authentication';

export default function authentication( initialState, action ) {
    if ( !initialState ) {
        return {
            error: false,
            isLoggedIn: false
        };
    }

    const newState = { ...initialState };

    switch( action.type ) {
        case actions.LOGIN_USER: return loginUser( newState );
        case actions.HAS_ERRORED: return hasErrored( newState, action.code );
        case actions.RESET_PASSWORD: return resetPassword( newState );
        case actions.SET_REDIRECT_URL: return setRedirectUrl( newState, action.redirectUrl );
        case actions.FIRST_LOGIN_TO_BUNDLES_PAGE: return setFirstLoginFlag( newState, action.isFirstLogin );
        default: return newState;
    }
}

function loginUser( newState ) {
    newState.isLoggedIn = !!localStorage.token;
    return newState;
}

function hasErrored( newState, code ) {

    newState.error = {};

    const hasErrored = true;
    let errorCode = code;

    newState.error[ 'hasErrored' ] = hasErrored;
    newState.error[ 'errorCode' ] = errorCode;

    return newState;
}

function setRedirectUrl( newState, redirectUrl ) {
    newState.redirectUrl = redirectUrl;

    return newState;
}

function resetPassword( newState ) {

    // return newState;
}

function setFirstLoginFlag( newState, isFirstLogin ) {
    newState.firstLoginToBundles = isFirstLogin;

    return newState;
}



// WEBPACK FOOTER //
// src/client/reducers/authentication/authentication.js